// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/movimenti-finanziamento/aggregato?societaId=&periodoDa=&periodoA=',
    requestBody: null,
    response: '{ success: true, data: { periodo, finanziamenti, totali } }'
  },
  {
    method: 'GET',
    endpoint: '/api/movimenti-finanziamento?societaId=&periodoDa=&periodoA=',
    requestBody: null,
    response: '{ success: true, data: [{ id, finanziamentoId, finanziamento, dataPagamento, quotaCapitale, quotaInteressi, spese, periodoCompetenzaDa, periodoCompetenzaA }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/finanziamenti?societaId=',
    requestBody: null,
    response: '{ finanziamenti: [{ id, descrizione, nomeBanca, cadenzaRata, numeroFinanziamento }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/movimenti-finanziamento/rate-disponibili?finanziamentoId=&includiId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, numeroRata, dataScadenza, importoRata, quotaCapitale, quotaInteressi }] }'
  },
  {
    method: 'PUT',
    endpoint: '/api/movimenti-finanziamento/:id',
    requestBody: '{ dataPagamento, quotaCapitale, quotaInteressi, spese, cadenzaCompetenza, modalitaCompetenza, periodoCompetenzaDa, periodoCompetenzaA, rataTeoricaId, note }',
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/movimenti-finanziamento',
    requestBody: '{ finanziamentoId, ... }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/movimenti-finanziamento/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
